// Translation data for multilanguage support
const translations = {
    en: {
        // Navigation
        "nav.home": "Home",
        "nav.company": "Company",
        "nav.about-us": "About us",
        "nav.it-academy": "IT Academy",
        "nav.elements": "Elements",
        "nav.support": "Support",
        "nav.contact-us": "Contact Us",
        "nav.it-solutions": "IT solutions",
        "nav.services": "Services",
        "nav.blog": "Blog",
        "nav.case-studies": "Case Studies",
        "nav.leadership": "Leadership",
        "nav.why-choose-us": "Why choose us",
        "nav.our-history": "Our history",
        "nav.faqs": "FAQs",
        "nav.careers": "Careers",
        "nav.pricing-plans": "Pricing plans",
        "nav.it-services": "IT Services",
        "nav.managed-it-services": "Managed IT Services",
        "nav.industries": "Industries",
        "nav.business-solution": "Business Solution",
        "nav.infotechno": "Infotechno",
        "nav.processing": "Processing",
        "nav.appointment": "Appointment",
        "nav.resolutions": "Resolutions",
        "nav.cybersecurity": "Cybersecurity",
        "nav.modern-it-company": "Modern IT Company",
        "nav.machine-learning": "Machine Learning",
        "nav.software-innovation": "Software Innovation",
        
        // Hero Section
        "hero.subtitle": "Technology and software",
        "hero.title": "SAM APPS - A Technology, Digital Software",
        "hero.button": "Join to IT",
        
        // Services
        "service.business-reform.title": "Business Reform",
        "service.business-reform.text": "We propose feasible & practical plans for successfully transform businesses based on.",
        "service.infrastructure.title": "Infrastructure Plan",
        "service.infrastructure.text": "Sam-Apps takes into account all conditions and budgets needed for building infrastructure plan.",
        "service.firewall.title": "Firewall Advancement",
        "service.firewall.text": "Enhancing the strength and security of firewalls to protect online data from malicious sources.",
        "service.desktop.title": "Desktop Computing",
        "service.desktop.text": "Programming is taken care of by our experienced and professional specialist in IT management.",
        
        // Section Titles
        "section.demos.subtitle": "Start with a demo",
        "section.demos.title": "09+ Unique Homepages for Multiple Purposes",
        "section.case-studies.title": "09+ Technological Case Study Layouts",
        "section.case-studies.text": "In general, analyses of famous case studies help your clients, partners, and visitors have a better understanding of what is going on in the market. Your helpful advice can also be beneficial for audiences, which keeps them coming back for more.",
        "section.case-studies.button": "Find out more",
        "section.headers.title": "07+ Beautiful Header Styles",
        "section.headers.text": "Alternating between a number of diverse headers helps your pages stay dynamic and refreshing to readers. Organizing your menu items with these headers to make things more accessible for readers and reduce the bounce rate.",
        "section.blog.title": "04+ Blog for Media News & Social Events",
        "section.blog.text": "Blog sidebar widgets from Sam-Apps come with an attention-grabbing feature image that can be configured from Customize menu. Choose a suitable layout for displaying images and craft valuable pieces of writing tu publish on your site.",
        "section.plugins.swiper": "Swiper Slider",
        "section.plugins.swiper.text": "Generate unlimited full-width HD retina ready sliders with effects",
        "section.plugins.fontawesome": "Font Awesome 5 Pro",
        "section.plugins.fontawesome.text": "Professional fonts and icons help improve readability & visual.",
        "section.features.subtitle": "Extra Features",
        "section.features.title": "Richness of Theme Features",
        "section.features.typography": "Expert Typography",
        "section.features.typography.text": "Your site's typography will benefit from beautiful fonts provided by Font Awesome 5 Pro plugin.",
        "section.features.speed": "Fast Loading Speed",
        "section.features.speed.text": "Sam-Apps gets a very high pagespeed scores on Pagespeed Insight, Pingdom Tools & GTmetrix.",
        "section.features.seo": "SEO Optimization",
        "section.features.seo.text": "All elements are fully optimized to help your site compete with other similar ones in search engine.",
        "section.features.browser": "Cross-browser Adaptability",
        "section.features.browser.text": "We run thorough tests on different browsers to ensure optimal performance on all devices.",
        "section.features.support": "Prompt Support",
        "section.features.support.text": "Any issues with theme configuration and site building will be solved promptly by our professionals.",
        "section.features.shortcodes": "Abundant Shortcodes",
        "section.features.shortcodes.text": "A wide ranging of shortcodes are added to Sam-Apps for assisting users on page building process.",
        
        // Footer
        "footer.title": "Take Steps to Get Closer <br> To The Sweet Smell Of Success Now",
        "footer.subtitle": "A High-growth Approach",
        "footer.button": "Get In Touch",
        
        // Demo Items
        "demo.view": "View Demo",
        "demo.appointment": "Appointment",
        "demo.infotechno": "InfoTechno",
        "demo.processing": "Processing",
        "demo.services": "Services",
        "demo.resolutions": "Resolutions",
        "demo.cybersecurity": "Cybersecurity",
        "demo.modern-it": "Modern IT Company",
        "demo.machine-learning": "Machine Learning",
        "demo.software-innovation": "Software innovation",
        
        // Mobile Menu
        "mobile.academy": "Academy",
        "mobile.elements": "Elements",
        "mobile.support": "Support",
        
        // Search
        "search.placeholder": "Search",
        
        // Toolbar
        "toolbar.quick-options": "Quick Options",
        "toolbar.support": "Support Center",
        "toolbar.contact": "Contact Us",
        
        // Common elements
        "common.now-hiring": "Now Hiring:",
        "common.search": "Search",
        "common.read-more": "Read more",
        "common.learn-more": "Learn more",
        "common.view-more": "View more",
        "common.get-in-touch": "Get in touch",
        "common.submit": "Submit",
        "common.send": "Send",
        "common.name": "Name",
        "common.email": "Email",
        "common.message": "Message",
        "common.phone": "Phone",
        "common.subject": "Subject",
        "common.talk-to-consultant": "Talk to a consultant",
        "common.join-us-now": "Join us now",
        "common.find-out-more": "Find out more",
        "common.contact-us-now": "Contact us now",
        "common.download-now": "Download now",
        "common.free-sample": "Free Sample",
        "common.get-started": "Get started",
        "common.send-message": "Send message",
        "common.discover-now": "Discover now"
    },
    uk: {
        // Navigation
        "nav.home": "Головна",
        "nav.company": "Компанія",
        "nav.about-us": "Про нас",
        "nav.it-academy": "IT Академія",
        "nav.elements": "Елементи",
        "nav.support": "Підтримка",
        "nav.contact-us": "Зв'язатися з нами",
        "nav.it-solutions": "IT рішення",
        "nav.services": "Послуги",
        "nav.blog": "Блог",
        "nav.case-studies": "Кейс-студії",
        "nav.leadership": "Керівництво",
        "nav.why-choose-us": "Чому обирають нас",
        "nav.our-history": "Наша історія",
        "nav.faqs": "Часті питання",
        "nav.careers": "Кар'єра",
        "nav.pricing-plans": "Тарифи",
        "nav.it-services": "IT Послуги",
        "nav.managed-it-services": "Управляючі IT Послуги",
        "nav.industries": "Галузі",
        "nav.business-solution": "Бізнес Рішення",
        "nav.infotechno": "Infotechno",
        "nav.processing": "Обробка",
        "nav.appointment": "Призначення",
        "nav.resolutions": "Рішення",
        "nav.cybersecurity": "Кібербезпека",
        "nav.modern-it-company": "Сучасна IT Компанія",
        "nav.machine-learning": "Машинне Навчання",
        "nav.software-innovation": "Інновації Програмного Забезпечення",
        
        // Hero Section
        "hero.subtitle": "Технології та програмне забезпечення",
        "hero.title": "SAM APPS - Технології, Цифрове Програмне Забезпечення",
        "hero.button": "Приєднатися до IT",
        
        // Services
        "service.business-reform.title": "Реформа Бізнесу",
        "service.business-reform.text": "Ми пропонуємо здійсненні та практичні плани для успішної трансформації бізнесу.",
        "service.infrastructure.title": "План Інфраструктури",
        "service.infrastructure.text": "Sam-Apps враховує всі умови та бюджети, необхідні для побудови плану інфраструктури.",
        "service.firewall.title": "Розвиток Мережевого Екрану",
        "service.firewall.text": "Підвищення міцності та безпеки мережевих екранів для захисту онлайн-даних від зловмисних джерел.",
        "service.desktop.title": "Настільні Обчислення",
        "service.desktop.text": "Програмування здійснюється нашими досвідченими та професійними спеціалістами з IT-менеджменту.",
        
        // Section Titles
        "section.demos.subtitle": "Почніть з демо",
        "section.demos.title": "09+ Унікальних Головних Сторінок для Різних Цілей",
        "section.case-studies.title": "09+ Технологічних Макетів Кейс-Студій",
        "section.case-studies.text": "Загалом, аналізи відомих кейс-студій допомагають вашим клієнтам, партнерам та відвідувачам краще зрозуміти, що відбувається на ринку. Ваші корисні поради також можуть бути корисними для аудиторії, що змушує їх повертатися за більшим.",
        "section.case-studies.button": "Дізнатися більше",
        "section.headers.title": "07+ Красивих Стилів Заголовків",
        "section.headers.text": "Чергування між кількома різноманітними заголовками допомагає вашим сторінкам залишатися динамічними та освіжаючими для читачів. Організація пунктів меню з цими заголовками робить речі більш доступними для читачів та зменшує показник відмов.",
        "section.blog.title": "04+ Блогів для Медіа Новини та Соціальних Подій",
        "section.blog.text": "Віджети бічної панелі блогу від Sam-Apps поставляються з привабливою зображенням функції, яку можна налаштувати з меню Налаштування. Виберіть відповідний макет для відображення зображень та створіть цінні статті для публікації на вашому сайті.",
        "section.plugins.swiper": "Слайдер Swiper",
        "section.plugins.swiper.text": "Створюйте необмежену кількість повноширинних HD retina готових слайдерів з ефектами",
        "section.plugins.fontawesome": "Font Awesome 5 Pro",
        "section.plugins.fontawesome.text": "Професійні шрифти та іконки допомагають покращити читабельність та візуальність.",
        "section.features.subtitle": "Додаткові Можливості",
        "section.features.title": "Багатство Можливостей Теми",
        "section.features.typography": "Експертна Типографія",
        "section.features.typography.text": "Типографія вашого сайту виграє від красивих шрифтів, наданих плагіном Font Awesome 5 Pro.",
        "section.features.speed": "Швидка Швидкість Завантаження",
        "section.features.speed.text": "Sam-Apps отримує дуже високі оцінки швидкості сторінок на Pagespeed Insight, Pingdom Tools та GTmetrix.",
        "section.features.seo": "SEO Оптимізація",
        "section.features.seo.text": "Всі елементи повністю оптимізовані, щоб допомогти вашому сайту конкурувати з іншими подібними в пошукових системах.",
        "section.features.browser": "Кросс-браузерна Сумісність",
        "section.features.browser.text": "Ми проводимо ретельні тести на різних браузерах, щоб забезпечити оптимальну продуктивність на всіх пристроях.",
        "section.features.support": "Швидка Підтримка",
        "section.features.support.text": "Будь-які проблеми з конфігурацією теми та побудовою сайту будуть вирішені швидко нашими професіоналами.",
        "section.features.shortcodes": "Багато Шорткодів",
        "section.features.shortcodes.text": "Широкий спектр шорткодів додано до Sam-Apps для допомоги користувачам у процесі створення сторінок.",
        
        // Footer
        "footer.title": "Зробіть Кроки, Щоб Наблизитися <br> До Солодкого Запаху Успіху Зараз",
        "footer.subtitle": "Підхід Високого Зростання",
        "footer.button": "Зв'язатися",
        
        // Demo Items
        "demo.view": "Переглянути Демо",
        "demo.appointment": "Призначення",
        "demo.infotechno": "InfoTechno",
        "demo.processing": "Обробка",
        "demo.services": "Послуги",
        "demo.resolutions": "Рішення",
        "demo.cybersecurity": "Кібербезпека",
        "demo.modern-it": "Сучасна IT Компанія",
        "demo.machine-learning": "Машинне Навчання",
        "demo.software-innovation": "Інновації Програмного Забезпечення",
        
        // Mobile Menu
        "mobile.academy": "Академія",
        "mobile.elements": "Елементи",
        "mobile.support": "Підтримка",
        
        // Search
        "search.placeholder": "Пошук",
        
        // Toolbar
        "toolbar.quick-options": "Швидкі Опції",
        "toolbar.support": "Центр Підтримки",
        "toolbar.contact": "Зв'язатися з нами",
        
        // Common elements
        "common.now-hiring": "Зараз наймаємо:",
        "common.search": "Пошук",
        "common.read-more": "Читати далі",
        "common.learn-more": "Дізнатися більше",
        "common.view-more": "Переглянути більше",
        "common.get-in-touch": "Зв'язатися",
        "common.submit": "Відправити",
        "common.send": "Надіслати",
        "common.name": "Ім'я",
        "common.email": "Електронна пошта",
        "common.message": "Повідомлення",
        "common.phone": "Телефон",
        "common.subject": "Тема",
        "common.talk-to-consultant": "Поговорити з консультантом",
        "common.join-us-now": "Приєднатися зараз",
        "common.find-out-more": "Дізнатися більше",
        "common.contact-us-now": "Зв'язатися зараз",
        "common.download-now": "Завантажити зараз",
        "common.free-sample": "Безкоштовний зразок",
        "common.get-started": "Почати",
        "common.send-message": "Надіслати повідомлення",
        "common.discover-now": "Відкрити зараз"
    },
    es: {
        // Navigation
        "nav.home": "Inicio",
        "nav.company": "Empresa",
        "nav.about-us": "Acerca de nosotros",
        "nav.it-academy": "Academia IT",
        "nav.elements": "Elementos",
        "nav.support": "Soporte",
        "nav.contact-us": "Contáctanos",
        "nav.it-solutions": "Soluciones IT",
        "nav.services": "Servicios",
        "nav.blog": "Blog",
        "nav.case-studies": "Casos de Estudio",
        "nav.leadership": "Liderazgo",
        "nav.why-choose-us": "Por qué elegirnos",
        "nav.our-history": "Nuestra historia",
        "nav.faqs": "Preguntas Frecuentes",
        "nav.careers": "Carreras",
        "nav.pricing-plans": "Planes de Precios",
        "nav.it-services": "Servicios IT",
        "nav.managed-it-services": "Servicios IT Gestionados",
        "nav.industries": "Industrias",
        "nav.business-solution": "Solución Empresarial",
        "nav.infotechno": "InfoTechno",
        "nav.processing": "Procesamiento",
        "nav.appointment": "Cita",
        "nav.resolutions": "Resoluciones",
        "nav.cybersecurity": "Ciberseguridad",
        "nav.modern-it-company": "Empresa IT Moderna",
        "nav.machine-learning": "Aprendizaje Automático",
        "nav.software-innovation": "Innovación de Software",
        
        // Hero Section
        "hero.subtitle": "Tecnología y software",
        "hero.title": "SAM APPS - Tecnología, Software Digital",
        "hero.button": "Únete a IT",
        
        // Services
        "service.business-reform.title": "Reforma Empresarial",
        "service.business-reform.text": "Proponemos planes viables y prácticos para transformar exitosamente las empresas.",
        "service.infrastructure.title": "Plan de Infraestructura",
        "service.infrastructure.text": "Sam-Apps tiene en cuenta todas las condiciones y presupuestos necesarios para construir el plan de infraestructura.",
        "service.firewall.title": "Avance del Firewall",
        "service.firewall.text": "Mejorando la fuerza y seguridad de los firewalls para proteger los datos en línea de fuentes maliciosas.",
        "service.desktop.title": "Computación de Escritorio",
        "service.desktop.text": "La programación está a cargo de nuestros especialistas experimentados y profesionales en gestión de TI.",
        
        // Section Titles
        "section.demos.subtitle": "Comienza con una demo",
        "section.demos.title": "09+ Páginas de Inicio Únicas para Múltiples Propósitos",
        "section.case-studies.title": "09+ Diseños de Casos de Estudio Tecnológicos",
        "section.case-studies.text": "En general, los análisis de casos de estudio famosos ayudan a sus clientes, socios y visitantes a comprender mejor lo que está sucediendo en el mercado. Sus consejos útiles también pueden ser beneficiosos para la audiencia, lo que los mantiene regresando por más.",
        "section.case-studies.button": "Descubre más",
        "section.headers.title": "07+ Estilos de Encabezado Hermosos",
        "section.headers.text": "Alternar entre varios encabezados diversos ayuda a que sus páginas se mantengan dinámicas y refrescantes para los lectores. Organizar los elementos del menú con estos encabezados hace las cosas más accesibles para los lectores y reduce la tasa de rebote.",
        "section.blog.title": "04+ Blog para Noticias de Medios y Eventos Sociales",
        "section.blog.text": "Los widgets de la barra lateral del blog de Sam-Apps vienen con una imagen de función llamativa que se puede configurar desde el menú Personalizar. Elija un diseño adecuado para mostrar imágenes y cree piezas valiosas de escritura para publicar en su sitio.",
        "section.plugins.swiper": "Swiper Slider",
        "section.plugins.swiper.text": "Genere sliders ilimitados de ancho completo HD retina listos con efectos",
        "section.plugins.fontawesome": "Font Awesome 5 Pro",
        "section.plugins.fontawesome.text": "Las fuentes e iconos profesionales ayudan a mejorar la legibilidad y visual.",
        "section.features.subtitle": "Características Extra",
        "section.features.title": "Riqueza de Características del Tema",
        "section.features.typography": "Tipografía Experta",
        "section.features.typography.text": "La tipografía de su sitio se beneficiará de las hermosas fuentes proporcionadas por el complemento Font Awesome 5 Pro.",
        "section.features.speed": "Velocidad de Carga Rápida",
        "section.features.speed.text": "Sam-Apps obtiene puntuaciones muy altas de velocidad de página en Pagespeed Insight, Pingdom Tools y GTmetrix.",
        "section.features.seo": "Optimización SEO",
        "section.features.seo.text": "Todos los elementos están completamente optimizados para ayudar a su sitio a competir con otros similares en los motores de búsqueda.",
        "section.features.browser": "Adaptabilidad Multi-navegador",
        "section.features.browser.text": "Ejecutamos pruebas exhaustivas en diferentes navegadores para garantizar un rendimiento óptimo en todos los dispositivos.",
        "section.features.support": "Soporte Rápido",
        "section.features.support.text": "Cualquier problema con la configuración del tema y la construcción del sitio será resuelto rápidamente por nuestros profesionales.",
        "section.features.shortcodes": "Códigos Cortos Abundantes",
        "section.features.shortcodes.text": "Se ha agregado una amplia gama de códigos cortos a Sam-Apps para ayudar a los usuarios en el proceso de construcción de páginas.",
        
        // Footer
        "footer.title": "Da Pasos para Acercarte <br> Al Dulce Aroma del Éxito Ahora",
        "footer.subtitle": "Un Enfoque de Alto Crecimiento",
        "footer.button": "Ponerse en Contacto",
        
        // Demo Items
        "demo.view": "Ver Demo",
        "demo.appointment": "Cita",
        "demo.infotechno": "InfoTechno",
        "demo.processing": "Procesamiento",
        "demo.services": "Servicios",
        "demo.resolutions": "Resoluciones",
        "demo.cybersecurity": "Ciberseguridad",
        "demo.modern-it": "Empresa IT Moderna",
        "demo.machine-learning": "Aprendizaje Automático",
        "demo.software-innovation": "Innovación de Software",
        
        // Mobile Menu
        "mobile.academy": "Academia",
        "mobile.elements": "Elementos",
        "mobile.support": "Soporte",
        
        // Search
        "search.placeholder": "Buscar",
        
        // Toolbar
        "toolbar.quick-options": "Opciones Rápidas",
        "toolbar.support": "Centro de Soporte",
        "toolbar.contact": "Contáctanos",
        
        // Common elements
        "common.now-hiring": "Contratando ahora:",
        "common.search": "Buscar",
        "common.read-more": "Leer más",
        "common.learn-more": "Aprender más",
        "common.view-more": "Ver más",
        "common.get-in-touch": "Ponerse en contacto",
        "common.submit": "Enviar",
        "common.send": "Enviar",
        "common.name": "Nombre",
        "common.email": "Correo electrónico",
        "common.message": "Mensaje",
        "common.phone": "Teléfono",
        "common.subject": "Asunto",
        "common.talk-to-consultant": "Hablar con un consultor",
        "common.join-us-now": "Únete ahora",
        "common.find-out-more": "Descubre más",
        "common.contact-us-now": "Contáctanos ahora",
        "common.download-now": "Descargar ahora",
        "common.free-sample": "Muestra Gratuita",
        "common.get-started": "Comenzar",
        "common.send-message": "Enviar mensaje",
        "common.discover-now": "Descubrir ahora"
    }
};

